import { AuthLayout, PasswordField, GoogleMark } from "./components/AuthLayout";
import { useState, useEffect, useRef } from "react";
import { entrarComEmail, entrarComGoogle as autenticarGoogle, solicitarCodigoSenha, confirmarCodigoSenha } from "./utils/printControlAuth";
import { googleCancelado, mensagemErroGoogle } from "./utils/googleAuthErrors";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { auth, db } from "./firebase";
import Cadastro from "./components/Cadastro";
import { RequisitosSenha } from "./components/RequisitosSenha";
import { senhaForte, MENSAGEM_SENHA_FRACA } from "./utils/senha";
import { APP_VERSION } from "./App";
import { buscarLojaParceira, lojaDaConta } from "./components/PainelLojaParceira";

const isCapacitorAndroid = window.Capacitor?.getPlatform?.() === "android";

const solicitarReset = ({ email }) => solicitarCodigoSenha(auth, email);
// Loja parceira não tem cadastro de vendedor: entra direto no painel da loja.
const sessaoDe = (u, loja, nome) => loja
  ? { nome:loja.nome, avatar:"🏪", uid:u.uid, email:u.email, lojaParceiraId:loja.id }
  : { nome:nome||u.displayName||u.email, avatar:"🧑‍💻", uid:u.uid, email:u.email };
const confirmarReset = dados => confirmarCodigoSenha(auth, dados);

export default function Login({ onLogin }) {
  const [cadastrando,  setCadastrando]  = useState(false);
  const [escolhendo,   setEscolhendo]   = useState(false); // "Criar conta": app ou loja parceira
  const [resetando,    setResetando]    = useState(false);
  const [resetStep,    setResetStep]    = useState(0); // 0=email, 1=código+senha, 2=sucesso
  // Loja parceira: a conta nasce sem senha (o fornecedor cadastra o e-mail);
  // o primeiro acesso é o mesmo fluxo do código de redefinição.
  const [primeiroAcesso, setPrimeiroAcesso] = useState(false);
  const [resetEmail,   setResetEmail]   = useState("");
  const [resetCode,    setResetCode]    = useState("");
  const [novaSenha,    setNovaSenha]    = useState("");
  const [confirmarS,   setConfirmarS]   = useState("");
  const [verNova,      setVerNova]      = useState(false);
  const [verConfirmar, setVerConfirmar] = useState(false);
  const [email,        setEmail]        = useState("");
  const [senha,        setSenha]        = useState("");
  const [erro,         setErro]         = useState("");
  const [loading,      setLoading]      = useState(false);
  const [verSenha,     setVerSenha]     = useState(false);
  const [shake,        setShake]        = useState(false);
  const [manterLogado, setManterLogado] = useState(()=>{
    try{ return localStorage.getItem("3dp_manter")==="true"; }catch{ return false; }
  });
  const [exeUrl, setExeUrl] = useState("");
  const [googleLoading, setGoogleLoading] = useState(false);
  const [googleUser, setGoogleUser] = useState(null); // usuário Google sem cadastro ainda -> completa no Cadastro
  const authPending = useRef(false);

  useEffect(()=>{
    getDoc(doc(db,"config","assinatura")).then(snap=>{
      if(!snap.exists()) return;
      const d = snap.data();
      if(d.exeUrl) setExeUrl(d.exeUrl);
    }).catch(()=>{});
  },[]);



  if (cadastrando) return (
    <Cadastro
      onVoltar={()=>{ setCadastrando(false); setGoogleUser(null); }}
      onCadastrado={onLogin}
      googleUser={googleUser}
    />
  );

  if (escolhendo) return <AuthLayout eyebrow="CRIAR CONTA" title="Como você vai usar o Print Control?" subtitle="Escolha uma opção para continuar.">
    <div className="auth-choices">
      <button type="button" className="auth-choice" onClick={()=>{ setEscolhendo(false); setCadastrando(true); }}>
        <span aria-hidden="true">🧑‍💻</span>
        <span><strong>Cadastrar no app</strong><small>Para quem imprime e vende: custos, pedidos, estoque e loja online. Comece com teste grátis.</small></span>
      </button>
      <button type="button" className="auth-choice" onClick={()=>{ setEscolhendo(false); setPrimeiroAcesso(true); setResetando(true); setResetEmail(email); setErro(""); }}>
        <span aria-hidden="true">🏪</span>
        <span><strong>Sou loja parceira</strong><small>Um fornecedor cadastrou sua loja? Crie sua senha com o código que enviamos ao seu e-mail e comece a vender.</small></span>
      </button>
    </div>
    <button type="button" className="auth-link auth-back" onClick={()=>setEscolhendo(false)}>← Voltar ao login</button>
  </AuthLayout>;

  if (resetando) {
    const voltarLogin = () => { setResetando(false); setPrimeiroAcesso(false); setResetStep(0); setResetEmail(""); setResetCode(""); setNovaSenha(""); setConfirmarS(""); setErro(""); };

    const enviarCodigo = async () => {
      if (!resetEmail.trim()) return setErro("Informe seu e-mail.");
      setLoading(true); setErro("");
      try {
        await solicitarReset({ email: resetEmail.trim() });
        setResetStep(1);
      } catch(e) { setErro(e.message || "Erro ao enviar código. Tente novamente."); }
      setLoading(false);
    };

    const confirmarSenha = async () => {
      if (!resetCode.trim() || resetCode.length !== 6) return setErro("Informe o código de 6 dígitos.");
      if (!senhaForte(novaSenha))    return setErro(MENSAGEM_SENHA_FRACA);
      if (novaSenha !== confirmarS)  return setErro("As senhas não coincidem.");
      setLoading(true); setErro("");
      try {
        await confirmarReset({ email: resetEmail.trim(), code: resetCode.trim(), novaSenha });
        setResetStep(2);
      } catch(e) { setErro(e.message || "Código inválido ou expirado."); }
      setLoading(false);
    };

    // Primeiro acesso da loja parceira usa o mesmo fluxo de código, com outros textos.
    const t = primeiroAcesso ? {
      eyebrow:"LOJA PARCEIRA", titulo:"Crie a senha da sua loja", sub:"Use o e-mail que o seu fornecedor cadastrou. Vamos mandar um código para confirmar que é você.",
      tituloOk:"Senha criada!", subOk:"Tudo pronto. Seus produtos, o PDV e as contas já estão esperando por você.",
      email:"E-mail da loja", passo2:"02 · Criar senha", senha:"Crie sua senha", botao:"Criar senha →", salvando:"Criando…",
      aviso:"Enviaremos um código de 6 dígitos. Não chegou em alguns minutos? Veja o spam ou peça ao fornecedor para reenviar o convite.",
    } : {
      eyebrow:undefined, titulo:"Vamos recuperar seu acesso", sub:"Em poucos passos, você volta aos seus projetos.",
      tituloOk:"Acesso recuperado!", subOk:"Sua senha foi alterada. Você já pode entrar novamente.",
      email:"E-mail da sua conta", passo2:"02 · Nova senha", senha:"Nova senha", botao:"Redefinir senha →", salvando:"Redefinindo…",
      aviso:"Enviaremos um código de 6 dígitos para redefinir sua senha.",
    };
    // Depois de criar a senha, a loja já entra (sem digitar tudo de novo).
    const entrarNaLoja = async () => {
      setLoading(true); setErro("");
      try {
        const cred = await entrarComEmail(auth, resetEmail, novaSenha);
        onLogin(sessaoDe(cred.user, await lojaDaConta(cred.user)), manterLogado);
      } catch { setErro("Não foi possível entrar. Volte ao login e entre com seu e-mail e a senha nova."); setLoading(false); }
    };

    return <AuthLayout eyebrow={t.eyebrow} title={resetStep===2?t.tituloOk:t.titulo} subtitle={resetStep===2?t.subOk:t.sub}>
      {resetStep<2&&<div className="auth-steps"><span className={resetStep===0?"is-active":""}>01 · Seu e-mail</span><span className={resetStep===1?"is-active":""}>{t.passo2}</span></div>}
      {resetStep===0&&<form className="auth-form" onSubmit={e=>{e.preventDefault();enviarCodigo();}}><div className="auth-field"><label htmlFor="reset-email">{t.email}</label><input id="reset-email" type="email" autoComplete="email" required placeholder="seu@email.com" value={resetEmail} onChange={e=>{setResetEmail(e.target.value);setErro("");}} /></div><p className="auth-notice">{t.aviso}</p>{erro&&<div className="auth-feedback" role="alert">{erro}</div>}<button className="auth-submit" disabled={loading}>{loading?"Enviando…":"Enviar código →"}</button></form>}
      {resetStep===1&&<form className="auth-form" onSubmit={e=>{e.preventDefault();confirmarSenha();}}><div className="auth-notice">Confira o código enviado para <strong>{resetEmail}</strong>. Se não encontrar, veja também a pasta de spam.</div><div className="auth-field"><label htmlFor="reset-code">Código de 6 dígitos</label><input id="reset-code" autoComplete="one-time-code" inputMode="numeric" pattern="[0-9]{6}" maxLength={6} required placeholder="000000" value={resetCode} onChange={e=>{setResetCode(e.target.value.replace(/\D/g,""));setErro("");}} /></div><PasswordField id="new-password" label={t.senha} value={novaSenha} onChange={e=>{setNovaSenha(e.target.value);setErro("");}} visible={verNova} onToggle={()=>setVerNova(v=>!v)} autoComplete="new-password" placeholder="Mín. 8 caracteres" /><RequisitosSenha senha={novaSenha} className="auth-password-rules" /><PasswordField id="confirm-password" label="Confirmar nova senha" value={confirmarS} onChange={e=>{setConfirmarS(e.target.value);setErro("");}} visible={verConfirmar} onToggle={()=>setVerConfirmar(v=>!v)} autoComplete="new-password" placeholder="Repita a nova senha" />{erro&&<div className="auth-feedback" role="alert">{erro}</div>}<button className="auth-submit" disabled={loading}>{loading?t.salvando:t.botao}</button><button type="button" className="auth-link" disabled={loading} onClick={()=>{setResetStep(0);setErro("");}}>Reenviar código ou alterar e-mail</button></form>}
      {resetStep===2?(primeiroAcesso?<>{erro&&<div className="auth-feedback" role="alert">{erro}</div>}<button type="button" className="auth-submit" disabled={loading} onClick={entrarNaLoja}>{loading?"Entrando…":"Entrar na minha loja →"}</button></>:<button type="button" className="auth-submit" onClick={voltarLogin}>Voltar para minha conta →</button>):<button type="button" className="auth-link auth-back" disabled={loading} onClick={voltarLogin}>← Voltar ao login</button>}
    </AuthLayout>;
  }

  const getErroMsg = (code) => ({
    "auth/invalid-email":          "E-mail inválido.",
    "auth/user-not-found":         "Usuário não encontrado.",
    "auth/wrong-password":         "Senha incorreta.",
    "auth/too-many-requests":      "Muitas tentativas. Aguarde.",
    "auth/network-request-failed": "Sem conexão com a internet.",
    "auth/invalid-credential":     "E-mail ou senha inválidos.",
  }[code] || "Erro ao entrar. Tente novamente.");

  const triggerShake = ()=>{ setShake(true); setTimeout(()=>setShake(false),500); };

  // Login OU cadastro com Google: se já existe users/{uid}, entra direto.
  // Se for a primeira vez, só aproveita o e-mail (e nome sugerido) do Google
  // e manda pra tela de cadastro completar empresa/logo — mesma exigência
  // do cadastro por e-mail, só pulando a criação de senha.
  const entrarComGoogle = async () => {
    if(authPending.current) return;
    authPending.current = true;
    let etapa = "google";
    setErro(""); setGoogleLoading(true);
    try {
      try { localStorage.setItem("3dp_manter", manterLogado?"true":"false"); } catch {}
      const cred = await autenticarGoogle(auth);
      const u = cred.user;
      etapa = "perfil";
      const snap = await getDoc(doc(db, "users", u.uid));
      const d = snap.data();
      const vendedor = snap.exists() && d?.cadastroCompleto !== false;
      const loja = vendedor ? null : await buscarLojaParceira(u.email);
      if (vendedor) {
        onLogin(sessaoDe(u, null, d.nome), manterLogado);
      } else if (loja) {
        onLogin(sessaoDe(u, loja), manterLogado);
      } else {
        // Grava um documento mínimo já no primeiro login. O Google cria a
        // conta no Auth no instante do clique, mas users/{uid} só nascia no
        // fim do formulário abaixo — quem desistia aqui ficava existindo no
        // Auth e invisível no painel admin pra sempre. `cadastroCompleto`
        // false é o que segura essa conta na tela de cadastro até terminar.
        if (!snap.exists()) {
          try {
            await setDoc(doc(db, "users", u.uid), {
              nome: u.displayName || "",
              empresa: "",
              email: u.email || "",
              plan: "pending",
              cadastroCompleto: false,
              primeiroLoginEm: serverTimestamp(),
              origem: "google",
            }, { merge: true });
          } catch (erro) {
            // Não impede o cadastro: o formulário grava o documento de novo.
            console.error("Não foi possível registrar o primeiro login:", erro);
          }
        }
        setGoogleUser(u);
        setCadastrando(true);
      }
    } catch(e) {
      const cancelou = googleCancelado(e);
      if (!cancelou) {
        triggerShake();
        setErro(mensagemErroGoogle(e,etapa));
      }
    }
    setGoogleLoading(false);
    authPending.current = false;
  };

  const entrar = async () => {
    if(authPending.current) return;
    setErro("");
    if (!email.trim()){ triggerShake(); return setErro("Informe o e-mail."); }
    if (!senha.trim()){ triggerShake(); return setErro("Informe a senha."); }
    authPending.current = true;
    setLoading(true);
    try {
      try { localStorage.setItem("3dp_manter", manterLogado?"true":"false"); } catch {}
      const cred = await entrarComEmail(auth, email, senha);
      const u = cred.user;
      onLogin(sessaoDe(u, await lojaDaConta(u)), manterLogado);
    } catch(e) {
      triggerShake();
      setErro(getErroMsg(e.code));
    }
    setLoading(false);
    authPending.current = false;
  };

  return <AuthLayout eyebrow="SEU ESPAÇO PARA CRIAR" title="Bom te ver por aqui!" subtitle="Entre para acompanhar seus pedidos e organizar suas próximas impressões." shake={shake} footer={<><span>Ainda não tem conta ou é loja parceira? </span><button type="button" className="auth-link" disabled={loading||googleLoading} onClick={()=>{ setEscolhendo(true); setErro(""); }}>Criar conta →</button>{!isCapacitorAndroid&&<div className="auth-downloads">{exeUrl&&<a href={exeUrl} target="_blank" rel="noopener noreferrer">Baixar para Windows · v{APP_VERSION}</a>}<a href="https://play.google.com/store/apps/details?id=com.Otto.printcontrol" target="_blank" rel="noopener noreferrer">Disponível no Google Play ↗</a></div>}</>}>
    <form className="auth-form" onSubmit={e=>{e.preventDefault();entrar();}}>
      <div className="auth-field"><label htmlFor="login-email">E-mail</label><input id="login-email" type="email" autoComplete="username" placeholder="seu@email.com" required value={email} onChange={e=>{setEmail(e.target.value);setErro("");}} /></div>
      <PasswordField id="login-password" label="Senha" value={senha} onChange={e=>{setSenha(e.target.value);setErro("");}} visible={verSenha} onToggle={()=>setVerSenha(v=>!v)} />
      <div className="auth-options"><label className="auth-remember"><input type="checkbox" checked={manterLogado} onChange={e=>setManterLogado(e.target.checked)} /> Manter conectado</label><button type="button" className="auth-link" disabled={loading||googleLoading} onClick={()=>{setResetando(true);setResetEmail(email);setErro("");}}>Esqueceu a senha?</button></div>
      {erro&&<div className="auth-feedback" role="alert">{erro}</div>}
      <button className="auth-submit" disabled={loading||googleLoading}>{loading?"Entrando na sua conta…":"Entrar no meu estúdio →"}</button>
    </form>
    <div className="auth-divider">ou use sua conta Google</div>
    <button type="button" className="auth-google" onClick={entrarComGoogle} disabled={googleLoading||loading}><GoogleMark />{googleLoading?"Conectando…":"Continuar com Google"}</button>
  </AuthLayout>;
}
